/**
 * AS9 mega menu behaviour (moved out of sections/header.liquid).
 * Loaded with `defer` so it is cached across pages and never blocks parsing.
 */
(() => {
  const OPEN_DELAY = 200;
  const CLOSE_DELAY = 360;
  const DESKTOP = window.matchMedia('(min-width: 990px)');

  const publish = (name, detail = {}) => {
    const payload = {
      ...detail,
      page_path: window.location.pathname,
      timestamp: Date.now(),
    };
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(`aurelia:${name}`, payload).catch(() => {});
      }
    } catch (e) {}
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: `aurelia_${name}`, ...payload });
    }
    window.dispatchEvent(new CustomEvent(`aurelia:${name}`, { detail: payload }));
  };

  const persistPath = (detail) => {
    const path = [detail.menu_category, detail.item_label, detail.interaction_type]
      .filter(Boolean)
      .join(' > ')
      .slice(0, 220);
    if (!path) return;

    try {
      let first = sessionStorage.getItem('as9_nav_first');
      if (!first) {
        first = path;
        sessionStorage.setItem('as9_nav_first', first);
      }
      sessionStorage.setItem('as9_nav_last', path);

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { __as_nav_first: first, __as_nav_last: path } }),
      }).catch(() => {});
    } catch (e) {}
  };

  const init = (root = document) => {
    const navs = root.querySelectorAll ? root.querySelectorAll('[data-as9-nav]:not([data-as9-ready])') : [];
    navs.forEach((nav) => {
      nav.dataset.as9Ready = 'true';
      const items = Array.from(nav.querySelectorAll('[data-as9-item].as9-nav__item--has-children'));
      let active = null;
      let openTimer = 0;
      let closeTimer = 0;

      const cancelOpen = () => { if (openTimer) window.clearTimeout(openTimer); openTimer = 0; };
      const cancelClose = () => { if (closeTimer) window.clearTimeout(closeTimer); closeTimer = 0; };

      const closeNow = (item) => {
        if (!item) return;
        item.classList.remove('is-open');
        const link = item.querySelector(':scope > .as9-nav__top-link');
        if (link) link.setAttribute('aria-expanded', 'false');
        if (active === item) active = null;
      };

      const scheduleClose = (item) => {
        cancelClose();
        closeTimer = window.setTimeout(() => closeNow(item), CLOSE_DELAY);
      };

      const openNow = (item, source) => {
        if (!DESKTOP.matches || !item) return;
        cancelOpen();
        cancelClose();
        if (active && active !== item) closeNow(active);
        const wasOpen = item.classList.contains('is-open');
        item.classList.add('is-open');
        const link = item.querySelector(':scope > .as9-nav__top-link');
        if (link) link.setAttribute('aria-expanded', 'true');
        active = item;
        if (!wasOpen) {
          publish('mega_menu_open', {
            menu_category: link ? link.dataset.as9Category || '' : '',
            interaction_source: source || 'hover',
          });
        }
      };

      items.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (!DESKTOP.matches) return;
          cancelClose();
          cancelOpen();
          openTimer = window.setTimeout(() => openNow(item, 'hover'), OPEN_DELAY);
        });
        item.addEventListener('mouseleave', () => {
          if (!DESKTOP.matches) return;
          cancelOpen();
          scheduleClose(item);
        });
        item.addEventListener('focusin', () => openNow(item, 'keyboard'));
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) scheduleClose(item);
        });
      });

      nav.addEventListener('mouseenter', cancelClose);
      nav.addEventListener('mouseleave', () => { if (active) scheduleClose(active); });
      nav.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && active) {
          const link = active.querySelector(':scope > .as9-nav__top-link');
          closeNow(active);
          if (link) link.focus();
        }
      });

      nav.addEventListener('click', (event) => {
        const target = event.target.closest('[data-as9-track]');
        if (!target) return;
        const type = target.dataset.as9Track || 'link';
        const detail = {
          interaction_type: type,
          menu_category: target.dataset.as9Category || '',
          item_label: target.dataset.as9Label || target.textContent.trim(),
          destination_url: target.href || '',
          product_id: target.dataset.as9ProductId || '',
          product_handle: target.dataset.as9ProductHandle || '',
          merch_role: target.dataset.as9Role || '',
        };
        const eventName = type === 'product'
          ? 'mega_menu_product_click'
          : type === 'editorial'
            ? 'mega_menu_editorial_click'
            : type === 'submenu'
              ? 'mega_menu_submenu_click'
              : 'mega_menu_category_click';
        publish(eventName, detail);
        persistPath(detail);
      });

      const resetViewport = () => {
        if (!DESKTOP.matches && active) closeNow(active);
      };
      if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', resetViewport);
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
